<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.1591 21.5896L36 4.01162C35.4935 3.99904 34.991 3.99677 34.4926 4.00434C19.295 4.23501 7.89352 13.6047 4 18.4123V35L34.1591 34.6699V21.5896ZM32.6591 33.1862V21.5896C32.6591 21.5374 32.6618 21.4852 32.6673 21.4333L34.3351 5.50743C20.22 5.79319 9.49072 14.2848 5.5 18.9548V33.4835L32.6591 33.1862Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 19H30.6193L32 8.00887C31.4905 7.99599 30.9864 7.99727 30.4878 8.01183C20.6811 8.2981 13.0291 13.7187 9.33519 17.5C8.80765 18.04 8.36083 18.5466 8 19ZM11.4938 17.5H29.296L30.2985 9.51918C21.9602 9.83792 15.2552 14.0729 11.4938 17.5Z"
      class="fill-current"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M24.25 22.25H30.75V23.75H24.25V22.25Z" class="fill-current" />
  </svg>
</template>
